import { Box } from "@mui/material";
import ViewForm from "src/components/common/ViewForm";
import { getStyles } from "src/styles/theme";
import defautlStyles from "./styles";
import ViewImages from "src/components/common/ViewImage";

export function IrrigationView({ data, images }: any) {
  const styles = getStyles(defautlStyles);

  const irrigationDetail = data;
  const viewData = {
    "Types of Irrigations": irrigationDetail.typesOfIrrigations,
    status: irrigationDetail.status,
    Observations: irrigationDetail.remark,
  };

  return (
    <Box>
      <Box {...styles("viewWrapper")}>
        {Object.entries(viewData).map((item) => (
          <ViewForm label={item[0]} value={item[1]} />
        ))}
        <Box {...styles("heading")}>Geo Tagged Images</Box>
        <Box {...styles("imageContainer")}>
          {images?.map((item) => (
            <ViewImages fileUrl={item.url} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
